import { z } from 'zod';
import { Integration } from 'libs/end-to-end/src/types/databases/integrations/integration';

export const IntegrationDataSetConfig = z.object({
  dataSetType: z.literal('Integration'),
  integration: Integration,
});

export type IntegrationDataSetConfig = z.infer<typeof IntegrationDataSetConfig>;
